import { VelvetSDK } from 'sdk'

export const fetchLoginCode = async () => {
  return await VelvetSDK.Authentication.service.fetchPinPairCode()
}

export const fetchCustomToken = async (code: number) => {
  return await VelvetSDK.Authentication.service.fetchPinPairToken(code)
}

export const loginWithCustomToken = async (token: string) => {
  await VelvetSDK.Authentication.service.loginPinPair(token)
}
